import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropTipoContrato,
  dropNaturezaAtividade,
  dropMotivoAlteracao,
  dropUnidadeSalario,
  dropRegimeJornada,
  dropTipoJornada,
  dropTipoRegime,
  dropTipoPrevidencia,
  dropHorasSemanais,
  dropDiaSemana,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import VirtualDrop from 'components/VirtualDrop';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Contrato = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const contratos = pessoal?.Contratos ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalContrato',
      id: item?.id,
      pessoal_id: pessoal?.id,
      tpcontr: item?.tpcontr || null,
      objdet: item?.objdet || '',
      categoria_trabalhador_id: item?.categoria_trabalhador_id || null,
      natatividade: item?.natatividade || null,
      local_trabalho_id: item?.local_trabalho_id || null,
      dtalteracao: item?.dtalteracao || null,
      mtvalter: item?.mtvalter || null,
      descalt: item?.descalt || '',
      dtef: item?.dtef || null,
      dttermino: item?.dttermino || null,
      justprorr: item?.justprorr || '',
      cargo_id: item?.cargo_id || null,
      codfuncao: item?.codfuncao || '',
      codcarreira: item?.codcarreira || '',
      dtingrcarr: item?.dtingrcarr || null,
      tpregjor: item?.tpregjor || null,
      tpjornada: item?.tpjornada || null,
      dsctpjornada: item?.dsctpjornada || '',
      qtdhrssem: item?.qtdhrssem || '',
      tmpparc: item?.tmpparc || null,
      dia: item?.dia || null,
      horario_id: item?.horario_id || null,
      vrsalfx: item?.vrsalfx || '',
      undsalfixo: item?.undsalfixo || null,
      dscsalvar: item?.dscsalvar || '',
      tpregprev: item?.tpregprev || null,
      tpplanrp: item?.tpplanrp || null,
      mesbase: item?.mesbase || '',
      sindcel_id: item?.sindcel_id || null,
      sindicato_id: item?.sindicato_id || null,
      aprendiz_id: item?.aprendiz_id || null,
      processo_id: item?.processo_id || null,
      Observacao: item?.Observacao || '',
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação e Tipo do Contrato" disableMargin />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="tpcontr"
            control={control}
            label="Tipo de Contrato"
            options={dropTipoContrato}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="categoria_trabalhador_id"
            label="Categoria do Trabalhador"
            options={drops?.CategoriaTrabalhador}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="natatividade"
            label="Natureza da Atividade"
            options={dropNaturezaAtividade}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VirtualDrop
            control={control}
            name="local_trabalho_id"
            label="Local de Trabalho"
            options={drops?.EntidadeEndereco}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            name="objdet"
            control={control}
            label="Objeto / Descrição"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Vigência" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            control={control}
            name="dtalteracao"
            label="Data da Alteração"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="mtvalter"
            control={control}
            label="Motivo da Alteração"
            options={dropMotivoAlteracao}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="dtef"
            type="date"
            control={control}
            label="Data da Efetivação da Alteração"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="descalt"
            control={control}
            label="Descrição da Alteração"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            name="dttermino"
            control={control}
            label="Data da Término"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input
            name="justprorr"
            control={control}
            label="Justificativa da Prorrogação"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Cargo e Carreira" />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            label="Cargo"
            name="cargo_id"
            control={control}
            options={drops?.Cargo}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="codfuncao" control={control} label="Código da Função" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            control={control}
            name="codcarreira"
            label="Código da Carreira"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            type="date"
            name="dtingrcarr"
            control={control}
            label="Data de Ingresso"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Jornada de Trabalho" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="tpregjor"
            control={control}
            options={dropRegimeJornada}
            label="Tipo de Regime de Jornada"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="tpjornada"
            control={control}
            label="Tipo de Jornada"
            options={dropTipoJornada}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            control={control}
            name="dsctpjornada"
            label="Descrição da Jornada"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            name="qtdhrssem"
            control={control}
            label="Quantidade de Horas Semanais de Trabalho"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="tmpparc"
            control={control}
            label="Tempo Parcial"
            options={dropHorasSemanais}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="dia"
            control={control}
            label="Dia da Semana"
            options={dropDiaSemana}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            name="horario_id"
            control={control}
            label="Horário"
            options={drops?.Horario}
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Remuneração" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask name="vrsalfx" control={control} label="Salário Fixo" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="undsalfixo"
            control={control}
            options={dropUnidadeSalario}
            label="Unidade do Salário Fixo"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="dscsalvar"
            control={control}
            label="Descrição de Salário Variável"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Previdência e Sindicato" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tpregprev"
            control={control}
            options={dropTipoRegime}
            label="Tipo de Regime Previdenciário"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tpplanrp"
            control={control}
            options={dropTipoPrevidencia}
            label="Tipo de Plano de Previdência"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask name="mesbase" label="Mês Base" control={control} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VirtualDrop
            name="sindcel_id"
            control={control}
            options={drops?.Entidade}
            label="Sindicato de Classe"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VirtualDrop
            name="sindicato_id"
            control={control}
            options={drops?.Entidade}
            label="Sindicato"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Outros" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VirtualDrop
            name="aprendiz_id"
            control={control}
            label="Aprendiz"
            options={drops?.Entidade}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="entidade_processos_id"
            label="Processo Relacionado"
            options={drops?.EntidadeProcessos?.filter(
              (f) => f?.entidade_id === pessoal?.funcionario_id
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            control={control}
            name="Observacao"
            label="Observação"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Contratos"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Contrato')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={contratos}
          columns={[
            {
              field: 'tpcontr',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'cargo',
              headerName: 'Cargo',
              width: 300,
              sortable: false,
            },
            {
              field: 'local_trabalho_id',
              headerName: 'Local de Trabalho',
              width: 300,
              sortable: false,
            },
            {
              field: 'vrsalfx',
              headerName: 'Salário Fixo',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value &&
                value?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }),
            },
            {
              field: 'dttermino',
              headerName: 'Data de Término',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'tpjornada',
              headerName: 'Tipo de Jornada',
              width: 300,
              sortable: false,
            },
            {
              field: 'categoria_trabalhador',
              headerName: 'Categoria do Trabalhador',
              width: 300,
              sortable: false,
            },
            {
              field: 'dtalteracao',
              headerName: 'Data de Alteração',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Contrato')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalContrato', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Contrato;
